import React, { useEffect } from "react";
import NightLayout from "../components/night/NightLayout";
import "../styles/night-legal.css";

const contactRoutes = [
  {
    title: "Artist and label support",
    text: "Catalog, releases, reports, payouts, access, and account questions.",
    action: "Open dashboard",
    href: "https://dashboard.bne.studio",
  },
  {
    title: "Partnerships",
    text: "Distribution, event, creator, brand, and platform partnership inquiries.",
    action: "Email partnerships",
    href: "mailto:partnerships@bne.studio",
  },
  {
    title: "General contact",
    text: "Press, product, billing, privacy, legal, and general business requests.",
    action: "Email BNE Studio",
    href: "mailto:support@bne.studio",
  },
];

export const ContactUsPage = () => {
  useEffect(() => {
    const prev = document.title;
    document.title = "Contact Us - BNE Studio";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <NightLayout>
      <main className="legal-page contact-page">
        <header className="legal-hero">
          <div className="wrap">
            <span className="eyebrow dot">Contact</span>
            <h1 className="grad-text">Talk to BNE Studio.</h1>
            <p>
              Tell us what you are building, what needs attention, or where your
              account needs help. We will route the request to the right team.
            </p>
            <div className="legal-meta">
              <span>bne.studio/contact-us</span>
              <a href="mailto:support@bne.studio">support@bne.studio</a>
            </div>
          </div>
        </header>

        <section className="legal-section">
          <div className="wrap contact-grid">
            <div className="contact-panel">
              <h2>Send a message</h2>
              <p>
                Use the secure form below for product questions, support
                requests, partnership notes, or general business inquiries.
              </p>
              <div
                className="contact-form-frame"
                data-tf-widget="YSVVWq2l"
                data-tf-opacity="100"
                data-tf-inline-on-mobile
                data-tf-iframe-props="title=BNE Contact Us"
                data-tf-transitive-search-params
                data-tf-auto-focus
                data-tf-medium="snippet"
              />
            </div>

            <aside className="contact-routes">
              {contactRoutes.map((route) => (
                <article className="contact-card" key={route.title}>
                  <h3>{route.title}</h3>
                  <p>{route.text}</p>
                  <a href={route.href}>{route.action}</a>
                </article>
              ))}
            </aside>
          </div>
        </section>
      </main>
    </NightLayout>
  );
};

export default ContactUsPage;
